/* TMF Reviews carousel — scroll-snap horizontal track with prev/next arrows.
   No deps. Keyboard, swipe, and mouse all work via native overflow scroll. */
class TmfReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-tmf-reviews-track]');
    this.prev  = this.querySelector('[data-tmf-reviews-prev]');
    this.next  = this.querySelector('[data-tmf-reviews-next]');
    if (!this.track) return;

    this.prev?.addEventListener('click', () => this.scrollByCard(-1));
    this.next?.addEventListener('click', () => this.scrollByCard(1));
    this.track.addEventListener('scroll', () => this.updateState(), { passive: true });
    window.addEventListener('resize', () => this.updateState(), { passive: true });

    this.updateState();
  }

  cardStep() {
    const card = this.track.querySelector('.tmf-review');
    if (!card) return this.track.clientWidth;
    const styles = getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  scrollByCard(direction) {
    this.track.scrollBy({ left: this.cardStep() * direction, behavior: 'smooth' });
  }

  updateState() {
    const max = this.track.scrollWidth - this.track.clientWidth - 1;
    const atStart = this.track.scrollLeft <= 1;
    const atEnd   = this.track.scrollLeft >= max;
    if (this.prev) this.prev.disabled = atStart;
    if (this.next) this.next.disabled = atEnd;
  }
}

if (!customElements.get('tmf-reviews-carousel')) {
  customElements.define('tmf-reviews-carousel', TmfReviewsCarousel);
}
